// extracted by mini-css-extract-plugin
module.exports = {"red":"_1kd2s4qqYC8tfrVQhqAkz7","nowrap":"_3Wpgj2wEn42YZxJ5s98WZP"};